import { praiseWizardFlow } from './praise.domain.js';
import { traverseReasonFlow, } from '../wizard-flow-utils.js';
export const praiseStepComponentMap = {
    // Employee selection steps
    'employee-selection': 'EmployeeSelection',
    'feedback-employee-selection': 'EmployeeSelection',
    'praise-employee-selection': 'EmployeeSelection',
    'praise-feedback-employee-selection': 'EmployeeSelection',
    // Date selection
    'date-selection': 'DateSelection',
    // Single choice steps
    'reason-selection': 'ChoiceList',
    'praise-type-selection': 'ChoiceList',
    'collaboration-service-type': 'ChoiceList',
    'information-sharing-type': 'ChoiceList',
    'communication-type-selection': 'ChoiceList',
    'schedule-agreement-type': 'ChoiceList',
    'speech-tone-details': 'ChoiceList',
    'general-conduct-details': 'ChoiceList',
    'body-language-details': 'ChoiceList',
    'framework-selection': 'ChoiceList',
    'additional-effects-details': 'ChoiceList',
    'feedback-recipient': 'ChoiceList',
    'praise-recipient': 'ChoiceList',
    'praise-feedback-recipient': 'ChoiceList',
    'goal-selection': 'GoalsChoice',
    'body-language-framework-selection': 'ChoiceList',
    'written-communication-framework-selection': 'ChoiceList',
    'verbal-expressions-framework-selection': 'ChoiceList',
    // Text area steps
    'expectations-details': 'TextArea',
    'schedule-agreement-details': 'TextArea',
    'praise-feedback-subject': 'TextArea',
    'feedback-subject': 'TextArea',
    'praise-subject': 'TextArea',
    'service-description': 'TextArea',
    'collaboration-description': 'TextArea',
    'information-sharing-details': 'TextArea',
    'written-messages-details': 'TextArea',
    'verbal-expressions-details': 'TextArea',
    // Range step
    'goal-impact-range': 'Range',
    // Multiple choice steps
    'additional-effects': 'ChoiceList',
    'company-values': 'CompanyValuesChoice',
    // review step
    'interaction-description': 'TextArea',
};
/**
 * Get all answers in the reason flow between reason-selection and goal-selection.
 * Returns an array of step-answer pairs showing the complete user journey through the reason flow.
 *
 * @param answers - The wizard answers to traverse
 * @param translateFn - Optional translation function for formatting questions and answers
 * @param formatContext - Optional context for formatting (employee info, date formatter)
 * @returns Array of objects containing stepId, answer, and optionally formattedQuestion and formattedAnswer
 *
 * @example
 * ```typescript
 * const reasonFlowAnswers = getPraiseReasonFlowAnswers(answers);
 * // Returns: [
 * //   { stepId: 'reason-selection', answer: ['collaboration-service'] },
 * //   { stepId: 'collaboration-service-type', answer: ['helping'] },
 * //   { stepId: 'service-description', answer: 'They helped me with...' }
 * // ]
 *
 * // With translation and formatting:
 * const formattedAnswers = getPraiseReasonFlowAnswers(
 *   answers,
 *   t,
 *   { selectedEmployee, formatDate }
 * );
 * // Returns: [
 * //   {
 * //     stepId: 'reason-selection',
 * //     answer: ['collaboration-service'],
 * //     formattedQuestion: 'What was the reason?',
 * //     formattedAnswer: 'Collaboration/Service'
 * //   },
 * //   ...
 * // ]
 * ```
 */
export const getPraiseReasonFlowAnswers = (answers, translateFn, formatContext) => {
    return traverseReasonFlow(praiseWizardFlow, answers, 'reason-selection', 'goal-selection', translateFn, formatContext);
};
